import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import {VENDOR_NAMES} from '@/constants/billingConstants';

const state = {
  filterData: {
    accounts: [
      "045665193992"
    ],
    products: [
      {
        code: "AmazonEC2",
        name: "EC2",
        parentCode: "SP_PRODUCT",
        codes: null
      }
    ],
    regions: [
      {
        code: "ap-northeast-2",
        name: "Asia Pacific (Seoul)",
        parentCode: "RGNCONVERT",
        codes: null
      }
    ],
    instanceFamilies: [
      "m5"
    ]
  },
  riList: {
    totalCount: 0,
    list: [
      {
        "reservedId": "569e8256-6d02-4367-b556-b87a683a001c",
        "linkedAccountId": "811293937992",
        "linkedAccountName": "Service Platform",
        "serviceCode": "EC2InstanceSavingsPlans",
        "serviceName": "EC2 Instance",
        "instanceType": "m5.xlarge",
        "normalizationFactor": "8",
        "regionCode": "ap-northeast-1",
        "regionName": "Asia Pacific (Tokyo)",
        "purchaseOption": "No Upfront",
        "remainingPeriod": 300,
        "startDate": "2020-08-21T08:27:36.000+0000",
        "endDate": "2021-08-21T08:27:35.000+0000",
        "duration": 31536000,
        "useType": null,
        "operationName": null,
        "commitPrice": 0.5,
        "upfrontPayment": 0.0,
        "noUpfrontPayment": 0.5,
        "status": "active",
        "currency": "USD",
        "arn": "arn:aws:savingsplans::811293937992:savingsplan/569e8256-6d02-4367-b556-b87a683a001c",
        "tag": null,
        "createDate": null
      }
    ]
  },
  selectedVendor: VENDOR_NAMES.AZURE,
  selectedViewByOption: '',
  isFilterLoading: true,
  isRiListLoading: true
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/azure-reserved/azure-ri/index.js